import { Dialog, DialogContent, DialogTitle, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import React from 'react';
import Swal from 'sweetalert2';
import strings from '../../Globalization';
import { CycleReviewForm } from '../../AppGrid/CycleReviewTable';
import { useSterilizerCycleInfo } from './Context';

const CycleReviewFormDialog = () => {
	const theme = useTheme();
	const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
	const { cycleReviewFormDialogOpen, onCloseCycleReviewFormDialog, cycleId, approvalStatusId, combos } =
		useSterilizerCycleInfo();
	const handleOnSetActiveRecord = (record, opts = { refresh: true }) => {
		if (typeof onCloseCycleReviewFormDialog === 'function') {
			onCloseCycleReviewFormDialog();
		}
	};

	const handleOnRecordSaved = (resData) => {
		onCloseCycleReviewFormDialog(resData.data === 'Updated');
		if (resData.data !== 'Updated') {
			Swal.fire({
				titleText: strings.Error,
				text:
					resData.data === 'Unauthorized User'
						? strings.ApproveCycleUnauthorized || resData.data || strings.Error
						: resData.data || strings.Error,
				icon: 'error',
				confirmButtonText: strings.Ok,
				allowOutsideClick: false
			});
		}
	};

	return (
		<Dialog
			open={cycleReviewFormDialogOpen}
			onClose={onCloseCycleReviewFormDialog}
			sx={{ '& .MuiDialog-paper': { minWidth: '60vw' } }}
			fullScreen={fullScreen}
		>
			<DialogTitle>
				<Typography fontSize={'inherit'} fontWeight="inherit" color="inherit">
					{strings.ConfirmForApproveCycle}
				</Typography>
			</DialogTitle>
			<DialogContent>
				<CycleReviewForm
					activeRecord={{ record: { selected: cycleId, statusId: approvalStatusId }, combos }}
					setActiveRecord={handleOnSetActiveRecord}
					containerProps={{ elevation: 0 }}
					onRecordSaved={handleOnRecordSaved}
					disableAlerts
				/>
			</DialogContent>
		</Dialog>
	);
};

export default CycleReviewFormDialog;
